import { StepConfig } from './types';

export const getStep = (steps: StepConfig<any>[], stepName: string = '') => (
  steps.find((step) => step.name === stepName)
);

export const getStepFromIndex = (steps: StepConfig<any>[], stepIndex: number) => (
  steps.find((_, index) => index === stepIndex)
);

export const getStepIndex = (steps: StepConfig<any>[], stepName: string = '') => (
  steps.findIndex((step) => step.name === stepName)
);
